export default {"src":"/_next/static/media/Frame_14416.82afea57.svg","height":160,"width":161,"blurWidth":0,"blurHeight":0};